// extracted by mini-css-extract-plugin
export default {"Dashboard":"dashboard_Dashboard__t5I81"};